import React, { useEffect, useState } from "react";
import { Link, useParams, useHistory } from "react-router-dom";
import { DropdownButton, Dropdown } from "react-bootstrap";
import api from "services/api";

// components
import ProfileDetails from "elements/dashboardElements/ProfileDetails";
import Cashier from "elements/dashboardElements/Cashier";
import AccountActvity from "elements/dashboardElements/AccountActvity";
import TransactionHistory from "elements/dashboardElements/TransactionHistory";
import GamingHistory from "elements/dashboardElements/GamingHistory";
import FreeSpins from "elements/dashboardElements/FreeSpins";
import Notifications from "elements/dashboardElements/Notifications";
import Messages from "elements/dashboardElements/Messages";
import AccessControl from "elements/dashboardElements/AccessControl";
import FavoriteGames from "elements/dashboardElements/FavoriteGames";
import ReferAndEarn from "elements/dashboardElements/ReferAndEarn";
// import NftHolders from "elements/dashboardElements/NftHolders";
import Verify from "elements/dashboardElements/Verify";
import Withdraw from "elements/dashboardElements/Withdraw";
import { Tabs, Tab } from "react-bootstrap";
import Translator, { __ } from "services/Translator";
export default function UserDashboard(props) {
  const params = useParams();
  const tab = params.tab;
  const [activeTab, setActiveTab] = useState("account-details");
  const [activeTabName, setActiveTabName] = useState("Account Details");
  const history = useHistory();

  const closeDetails = () => {
    history.push("/games/all");
  };

  const [travelingToRight, setTravelingToRight] = useState(false);

  useEffect(() => {
    setActiveTab(tab);

    // Handle tab parameter mapping
    if (tab === "favorite-games") {
      setKey("FavoriteGames");
    } else if (tab === "account-details") {
      setKey("account");
    } else if (tab === "verify") {
      setKey("verify");
    } else if (tab === "transaction-history") {
      setKey("TransactionHistory");
    } else if (tab === "account-activity") {
      setKey("AccountActivity");
    } else if (tab === "gaming-history") {
      setKey("GamingHistory");
    } else if (tab === "responsible-gaming") {
      setKey("ResponsibleGaming");
    }

    setTravelingToRight(true);
    setTimeout(function () {
      setTravelingToRight(false);
    }, 500);

    // alert(tab)
  }, [tab]);

  //Verify id checking

  const [level2submitted, setLevel2submitted] = useState(false);
  const [level2Verification, setLevel2Verification] = useState(false);

  const [level3submitted, setLevel3submitted] = useState(false);
  const [level3Verification, setLevel3Verification] = useState(false);

  const [level4submitted, setLevel4submitted] = useState(false);
  const [level4Verification, setLevel4Verification] = useState(false);

  const getIdUploads = async () => {
    var response = await api.get("/id-uploads");
    console.log("id-uploadsid-uploads", response);
    if (response.status === 200 && response.data) {
      if (response.data.poif && response.data.poib) {
        if (
          response.data.poif.approved == "approved" &&
          response.data.poib.approved == "approved"
        ) {
          setLevel2Verification(true);
        } else if (
          response.data.poif.approved == "submitted" &&
          response.data.poib.approved == "submitted"
        ) {
          setLevel2submitted(true);
        }
      }

      if (response.data.poa) {
        if (response.data.poa.approved == "approved") {
          setLevel3Verification(true);
        } else if (response.data.poa.approved == "submitted") {
          setLevel3submitted(true);
        }
      }
      if (response.data.sof) {
        if (response.data.sof.approved == "approved") {
          setLevel4Verification(true);
        } else if (response.data.sof.approved == "submitted") {
          setLevel4submitted(true);
        }
      }
    }
  };

  useEffect(() => {
    if (props.isAuthenticated) {
      getIdUploads();
    }
  }, []);

  const [showMainNotification, setShowMainNotification] = useState(false);
  useEffect(() => {
    if (
      props.freeSpinCount > 0 ||
      props.notifictionCount > 0 ||
      props.messageCount ||
      !level2submitted ||
      !level3submitted
    ) {
      setShowMainNotification(true);
    } else {
      setShowMainNotification(false);
    }
  }, [props]);

  //Custom action for Tabs
  const [key, setKey] = useState("account");

  const handleSelect = (k) => {
    console.log(`Selected tab: ${k}`);
    // Add your custom action here
    customAction(k);
    setKey(k);
  };

  const customAction = (selectedKey) => {
    switch (selectedKey) {
      case "account":
        console.log("Home tab selected");
        // Add any custom logic for the Home tab here
        break;
      case "verify":
        console.log("Profile tab selected");
        // Add any custom logic for the Profile tab here
        break;
      case "TransactionHistory":
        console.log("Contact tab selected");
        // Add any custom logic for the Contact tab here
        break;

      case "AccountActivity":
        console.log("Contact tab selected");
        // Add any custom logic for the Contact tab here
        break;
      case "GamingHistory":
        console.log("Contact tab selected");
        // Add any custom logic for the Contact tab here
        break;
      case "ResponsibleGaming":
        console.log("Contact tab selected");
        // Add any custom logic for the Contact tab here
        break;
      case "FavoriteGames":
        console.log("Favorite Games tab selected");
        // Add any custom logic for the Favorite Games tab here
        break;
      default:
        break;
    }
  };

  //Edit Account Action
  const [editAccountAction, setEditAccountAction] = useState(false);

  const handleDataFromProfileDetails = (childData) => {
    setEditAccountAction(childData);
    if (childData == true) {
      setKey("verify");
    }
  };

  return (
    <div className="container">
      <div
        className={
          "userDashboard " + (travelingToRight ? "travelingToRight" : "")
        }
      >
        {[
          "account-details",
          "verify",
          "TransactionHistory",
          "AccountActivity",
          "GamingHistory",
          "ResponsibleGaming",
          "FavoriteGames",
          "favorite-games",
        ].includes(activeTab) && (
            <>
              <div className="account_tabs">
                <Tabs
                  defaultActiveKey="account"
                  id="uncontrolled-tab-example"
                  className="mb-3"
                  activeKey={key}
                  onSelect={handleSelect}
                >
                  <Tab eventKey="account" title={__("Account")}>
                    <ProfileDetails
                      sendDataToParent={handleDataFromProfileDetails}
                      {...props}
                    />
                  </Tab>
                  <Tab
                    eventKey="verify"
                    title={
                      ((!level2submitted || !level3submitted) && (
                        <>
                          {__("Verify")}{" "}
                          <div className="notification_round"></div>
                        </>
                      )) ||
                      ((level2submitted || level3submitted) && (
                        <>
                          {__("Verify")}{" "}
                          <div className="notification_round orenge"></div>
                        </>
                      ))
                    }
                  >
                    {(!level2submitted || !level3submitted) && (
                      <div className="notification_round"></div>
                    )}

                    {level2submitted && level3submitted && (
                      <div className="notification_round orenge"></div>
                    )}
                    <Verify {...props} />
                  </Tab>
                  <Tab
                    eventKey="TransactionHistory"
                    title={__("Transaction History")}
                  >
                    <TransactionHistory {...props} />
                  </Tab>
                  <Tab eventKey="AccountActivity" title={__("Account Activity")}>
                    <AccountActvity {...props} />
                  </Tab>
                  <Tab eventKey="GamingHistory" title={__("Gaming History")}>
                    <GamingHistory {...props} />
                  </Tab>

                  <Tab eventKey="ResponsibleGaming" title={__("Responsible Gaming")}>
                    <AccessControl {...props} />
                  </Tab>
                  <Tab eventKey="FavoriteGames" title={__("Favorite Games")}>
                    <FavoriteGames {...props} />
                  </Tab>
                </Tabs>
              </div>
            </>
          )}

        {activeTab === "cashier" && <Cashier {...props} />}

        {activeTab === "transaction-history" && (
          <TransactionHistory {...props} />
        )}

        {activeTab === "free-spins" && <FreeSpins {...props} />}
        {activeTab === "notifications" && <Notifications {...props} />}
        {activeTab === "messages" && <Messages {...props} />}

        {activeTab === "my-games" && <FavoriteGames {...props} />}
        {activeTab === "refer-and-earn" && <ReferAndEarn {...props} />}
        {/* {activeTab === "nft-holders" && <NftHolders {...props} />} */}

        {activeTab === "withdraw" && <Withdraw {...props} />}
      </div>
    </div>
  );
}
